module.exports = __webpack_public_path__ + "0ff709c836919936e094f45b1ada6640.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/404.png
// module id = 342
// module chunks = 7